import { render, staticRenderFns } from "./MagnakataContactForm.vue?vue&type=template&id=48302f7c&"
import script from "./MagnakataContactForm.vue?vue&type=script&lang=js&"
export * from "./MagnakataContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports